module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ripple-button",
    attrs: {
      "ripple": ""
    },
    on: {
      "mousedown": _vm.onDown,
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "ripple--container"
  }), _vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e6ab0c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RippleButton.vue
// module id = 145
// module chunks = 1